import { browsersList, IBrowserInfo } from './browsersList';

export function getBrowserInfo(userAgent?: string): IBrowserInfo | null {
  const ua = userAgent || window.navigator.userAgent;
  const browser = browsersList.find((browser) => browser.regex.test(ua));
  if (!browser) {
    return null;
  }
  return browser.describe(ua);
}
